module.exports = __webpack_public_path__ + "resources/img/img_datahunt7_jp.803ca9dd6672492a84b53451465f0b9d.png";